import React from "react";
import PropTypes from "prop-types";
import "./index.scss";

const CheckBox = ({ field, label, ...props }) => (
  <div className="checkbox-wrapper">
    <input type="checkbox" className="check-box" {...props} {...field} />
    <label className="label">{label}</label>
  </div>
);

CheckBox.propTypes = {
  field: PropTypes.objectOf(PropTypes.any),
  label: PropTypes.string,
};

CheckBox.defaultProps = {
  field: {},
  label: "",
};

export default CheckBox;
